import { contentStepSchema } from 'src/features/programsV2/schemas/contentStepSchema';

import { Program, ProgramFeatureName } from '../../../types/program';
import { formatContentStepValues } from './formatContentStepValues';

export const verifyCompletedContentStep = async (program?: Program | null) => {
  if (!program) return false;

  const hasValidContents = program.modules.some(
    module => module.contents.length >= 1
  );

  const selectedGenders = program.features.find(
    feature => feature.name === ProgramFeatureName.Gender
  );

  const formattedValues = formatContentStepValues(program);
  try {
    await contentStepSchema.validate(formattedValues, {
      abortEarly: false,
      context: { gender: selectedGenders?.value },
    });
    return hasValidContents;
  } catch (error) {
    return false;
  }
};
